import { createCommand } from './plugin-factory';
import { ACTIONS } from './states';
export var updateAgents = function updateAgents(_ref) {
  var agents = _ref.agents,
    defaultAgent = _ref.defaultAgent;
  return createCommand(function () {
    return {
      type: ACTIONS.UPDATE_PLUGIN_STATE,
      data: {
        // Exclude the default agent from the list of agents
        // See https://product-fabric.atlassian.net/browse/EDF-881
        agents: agents.filter(function (agent) {
          return agent.namedId !== 'ai_mate_agent';
        }),
        defaultAgent: defaultAgent
      }
    };
  });
};
export var openBrowseAgentsModal = function openBrowseAgentsModal(open, rawPositions) {
  // Convert rawPositions into a structured format if provided.
  // This ensures that when the browse agents modal is closed,
  // the selection is restored correctly.
  var positions = rawPositions && {
    startPos: rawPositions[0],
    endPos: rawPositions[1]
  };
  return createCommand(function () {
    return {
      type: ACTIONS.UPDATE_PLUGIN_STATE,
      data: {
        isBrowseModalOpen: open,
        positions: positions
      }
    };
  });
};
export var updatePublish = function updatePublish(publish) {
  return createCommand(function () {
    return {
      type: ACTIONS.UPDATE_PLUGIN_STATE,
      data: {
        publish: publish
      }
    };
  });
};
export var updateEnabled = function updateEnabled(enabled) {
  return createCommand(function () {
    return {
      type: ACTIONS.UPDATE_PLUGIN_STATE,
      data: {
        enabled: enabled
      }
    };
  });
};